import { sidemenu } from '../config/index';

const dashboard = sidemenu.filter((menu) => menu.path !== '/settings');

export default dashboard;
